import { fetchPost, fetchGet, fetchPut, fetchDelete } from '../services/Apiservice'
import { customerUploader as customerFormUploader } from './formuploader/customer'

/**
 * Get customer list from API
 */
export const customerList = (data) => {
    return fetchGet('/customers', data)
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Create new customer from API
 */
export const customerCreate = (data) => {
    const formData = customerFormUploader(data);

    return fetchPost('/customers', formData)
    .then((res) => {
        return res
    })
    .catch((res) => {
        throw res
    })
}

/**
 * Edit customer details from API
 */
export const customerEdit = (id, data) => {
    const formData = customerFormUploader(data)

    return fetchPost(`/customers/${id}/edit`, formData)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Get customer details from API
 */
export const customerDetail = (id) => {
    return fetchGet(`/customers/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Delete customer data through API
 */
export const customerDelete = (id) => {
    return fetchDelete(`/customers/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Toggle customer status through API
 */
export const customerToggleStatus = (id) => {
    return fetchPost(`/customers/${id}/toggle-status`)
        .then(res => res)
        .catch(err => { throw err })
}

// Backward compatibility export
export const customersApi = {
    getAll: customerList,
    getById: customerDetail,
    create: customerCreate,
    update: customerEdit,
    delete: customerDelete,
    toggleStatus: customerToggleStatus,
}

